export default __webpack_public_path__ + "static/media/ed5.cd68f402.jpg";